import React, { useEffect, useRef } from "react"
import { Animated, Pressable } from "react-native"

const GrayOutComponent = (props) => {
    const { visible = false, opacity = 0.25, onPress = () => {} } = props

    const fadeAnim = useRef(new Animated.Value(0)).current

    useEffect(() => {
        Animated.timing(fadeAnim, {
            toValue: opacity,
            duration: 300,
            useNativeDriver: true,
        }).start()

        return () => {
            Animated.timing(fadeAnim, {
                toValue: 0,
                duration: 200,
                useNativeDriver: true,
            }).start()
        }
    }, [])

    return (
        <>
            {visible && (
                <Pressable
                    onPress={onPress}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 8,
                        elevation: 8,
                    }}
                >
                    <Animated.View
                        style={{
                            flex: 1,
                            backgroundColor: "rgba(0, 0, 0, 1)",
                            opacity: fadeAnim,
                        }}
                    />
                </Pressable>
            )}
        </>
    )
}

export default GrayOutComponent
